const o={primary:{textColor:"blue60",backgroundColor:"blue10"},success:{textColor:"success100",backgroundColor:"success10"},secondary:{textColor:"black80",backgroundColor:"black20"},warning:{textColor:"warning100",backgroundColor:"warning10"}};export{o as ChipModes};
//# sourceMappingURL=constants.js.map
